import React from "react";
import Navigation from "../partials/Navigation";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import {Helmet} from "react-helmet";
import CoursePage from "../partials/Courses/CoursePage";

const TeacherGuide = () => {

    return (
        <div className="main-wrapper">

            <Helmet>
				<title>Lärarhandledning</title>
				<meta name="description" content="" />
			</Helmet>

            <Navigation />

            <div className="page-content-wrap">
                <HorizontalNav title="Lärarhandledning" />

                <div className="pt-5 pb-5 pb-lg-6 pt-lg-0 page-content-inner position-relative">
                    <CoursePage courseid="28964" slug="lararhandledning" />
                </div>
            </div>
        </div>
    )
}

export default TeacherGuide;